"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partnerPaymentTerms = void 0;
const enums_1 = require("../enums");
const europeBillingEntities = [
    enums_1.BillingEntityCode.FORTO_DE,
    enums_1.BillingEntityCode.FORTO_ES,
    enums_1.BillingEntityCode.FORTO_NL,
    enums_1.BillingEntityCode.FORTO_ZOEY,
    enums_1.BillingEntityCode.FORTO_PL,
    enums_1.BillingEntityCode.FORTO_IT,
];
const chinaBillingEntities = [
    enums_1.BillingEntityCode.FORTO_CN,
    enums_1.BillingEntityCode.FORTO_NGB,
    enums_1.BillingEntityCode.FORTO_TSN,
    enums_1.BillingEntityCode.FORTO_SZX,
    enums_1.BillingEntityCode.FORTO_SHA,
];
const allBillingEntities = [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN, ...chinaBillingEntities];
exports.partnerPaymentTerms = {
    '0D': {
        code: enums_1.PartnerPaymentTerm['0D'],
        displayCode: '0D',
        bcCode: '0D',
        swivelCode: '0D',
        syncCode: '0D',
        description: '0 days',
        applicableBillingEntities: allBillingEntities,
    },
    '1D': {
        code: enums_1.PartnerPaymentTerm['1D'],
        displayCode: '1D',
        bcCode: '1D',
        swivelCode: '1D',
        syncCode: '1D',
        description: '1 day',
        applicableBillingEntities: europeBillingEntities,
    },
    '2D': {
        code: enums_1.PartnerPaymentTerm['2D'],
        displayCode: '2D',
        bcCode: '2D',
        swivelCode: '2D',
        syncCode: '2D',
        description: '2 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '3D': {
        code: enums_1.PartnerPaymentTerm['3D'],
        displayCode: '3D',
        bcCode: '3D',
        swivelCode: '3',
        syncCode: '3',
        description: '3 days',
        applicableBillingEntities: [...europeBillingEntities, ...chinaBillingEntities],
    },
    '4D': {
        code: enums_1.PartnerPaymentTerm['4D'],
        displayCode: '4D',
        bcCode: '4D',
        swivelCode: '4D',
        syncCode: '4D',
        description: '4 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '5D': {
        code: enums_1.PartnerPaymentTerm['5D'],
        displayCode: '5D',
        bcCode: '5D',
        swivelCode: '5',
        syncCode: '5',
        description: '5 days',
        applicableBillingEntities: allBillingEntities,
    },
    '6D': {
        code: enums_1.PartnerPaymentTerm['6D'],
        displayCode: '6D',
        bcCode: '6D',
        swivelCode: '6D',
        syncCode: '6D',
        description: '6 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '7D': {
        code: enums_1.PartnerPaymentTerm['7D'],
        displayCode: '7D',
        bcCode: '7D',
        swivelCode: '7',
        syncCode: '7',
        description: '7 days',
        applicableBillingEntities: allBillingEntities,
    },
    '8D': {
        code: enums_1.PartnerPaymentTerm['8D'],
        displayCode: '8D',
        bcCode: '8D',
        swivelCode: '8D',
        syncCode: '8D',
        description: '8 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '9D': {
        code: enums_1.PartnerPaymentTerm['9D'],
        displayCode: '9D',
        bcCode: '9D',
        swivelCode: '9D',
        syncCode: '9D',
        description: '9 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '10D': {
        code: enums_1.PartnerPaymentTerm['10D'],
        displayCode: '10D',
        bcCode: '10D',
        swivelCode: '10D',
        syncCode: '10D',
        description: '10 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '11D': {
        code: enums_1.PartnerPaymentTerm['11D'],
        displayCode: '11D',
        bcCode: '11D',
        swivelCode: '11D',
        syncCode: '11D',
        description: '11 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '12D': {
        code: enums_1.PartnerPaymentTerm['12D'],
        displayCode: '12D',
        bcCode: '12D',
        swivelCode: '12',
        syncCode: '12',
        description: '12 days',
        applicableBillingEntities: [...europeBillingEntities, ...chinaBillingEntities],
    },
    '13D': {
        code: enums_1.PartnerPaymentTerm['13D'],
        displayCode: '13D',
        bcCode: '13D',
        swivelCode: '13D',
        syncCode: '13D',
        description: '13 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '14D': {
        code: enums_1.PartnerPaymentTerm['14D'],
        displayCode: '14D',
        bcCode: '14D',
        swivelCode: '14',
        syncCode: '14',
        description: '14 days',
        applicableBillingEntities: allBillingEntities,
    },
    '15D': {
        code: enums_1.PartnerPaymentTerm['15D'],
        displayCode: '15D',
        bcCode: '15D',
        swivelCode: '15',
        syncCode: '15',
        description: '15 days',
        applicableBillingEntities: allBillingEntities,
    },
    '16D': {
        code: enums_1.PartnerPaymentTerm['16D'],
        displayCode: '16D',
        bcCode: '16D',
        swivelCode: '16D',
        syncCode: '16D',
        description: '16 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '17D': {
        code: enums_1.PartnerPaymentTerm['17D'],
        displayCode: '17D',
        bcCode: '17D',
        swivelCode: '17D',
        syncCode: '17D',
        description: '17 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '18D': {
        code: enums_1.PartnerPaymentTerm['18D'],
        displayCode: '18D',
        bcCode: '18D',
        swivelCode: '18',
        syncCode: '18',
        description: '18 days',
        applicableBillingEntities: allBillingEntities,
    },
    '19D': {
        code: enums_1.PartnerPaymentTerm['19D'],
        displayCode: '19D',
        bcCode: '19D',
        swivelCode: '19D',
        syncCode: '19D',
        description: '19 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '20D': {
        code: enums_1.PartnerPaymentTerm['20D'],
        displayCode: '20D',
        bcCode: '20D',
        swivelCode: '20',
        syncCode: '20',
        description: '20 days',
        applicableBillingEntities: allBillingEntities,
    },
    '21D': {
        code: enums_1.PartnerPaymentTerm['21D'],
        displayCode: '21D',
        bcCode: '21D',
        swivelCode: '21',
        syncCode: '21',
        description: '21 days',
        applicableBillingEntities: allBillingEntities,
    },
    '22D': {
        code: enums_1.PartnerPaymentTerm['22D'],
        displayCode: '22D',
        bcCode: '22D',
        swivelCode: '22D',
        syncCode: '22D',
        description: '22 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '23D': {
        code: enums_1.PartnerPaymentTerm['23D'],
        displayCode: '23D',
        bcCode: '23D',
        swivelCode: '23D',
        syncCode: '23D',
        description: '23 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '24D': {
        code: enums_1.PartnerPaymentTerm['24D'],
        displayCode: '24D',
        bcCode: '24D',
        swivelCode: '24D',
        syncCode: '24D',
        description: '24 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '25D': {
        code: enums_1.PartnerPaymentTerm['25D'],
        displayCode: '25D',
        bcCode: '25D',
        swivelCode: '25D',
        syncCode: '25D',
        description: '25 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '26D': {
        code: enums_1.PartnerPaymentTerm['26D'],
        displayCode: '26D',
        bcCode: '26D',
        swivelCode: '26D',
        syncCode: '26D',
        description: '26 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '27D': {
        code: enums_1.PartnerPaymentTerm['27D'],
        displayCode: '27D',
        bcCode: '27D',
        swivelCode: '27D',
        syncCode: '27D',
        description: '27 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '28D': {
        code: enums_1.PartnerPaymentTerm['28D'],
        displayCode: '28D',
        bcCode: '28D',
        swivelCode: '28D',
        syncCode: '28D',
        description: '28 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '29D': {
        code: enums_1.PartnerPaymentTerm['29D'],
        displayCode: '29D',
        bcCode: '29D',
        swivelCode: '29D',
        syncCode: '29D',
        description: '29 days',
        applicableBillingEntities: [...europeBillingEntities, enums_1.BillingEntityCode.FORTO_VN],
    },
    '30D': {
        code: enums_1.PartnerPaymentTerm['30D'],
        displayCode: '30D',
        bcCode: '30D',
        swivelCode: '30',
        syncCode: '30',
        description: '30 days',
        applicableBillingEntities: allBillingEntities,
    },
    '31D': {
        code: enums_1.PartnerPaymentTerm['31D'],
        displayCode: '31D',
        bcCode: '31D',
        swivelCode: '31D',
        syncCode: '31D',
        description: '31 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '32D': {
        code: enums_1.PartnerPaymentTerm['32D'],
        displayCode: '32D',
        bcCode: '32D',
        swivelCode: '32D',
        syncCode: '32D',
        description: '32 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '33D': {
        code: enums_1.PartnerPaymentTerm['33D'],
        displayCode: '33D',
        bcCode: '33D',
        swivelCode: '33D',
        syncCode: '33D',
        description: '33 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '34D': {
        code: enums_1.PartnerPaymentTerm['34D'],
        displayCode: '34D',
        bcCode: '34D',
        swivelCode: '34D',
        syncCode: '34D',
        description: '34 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '35D': {
        code: enums_1.PartnerPaymentTerm['35D'],
        displayCode: '35D',
        bcCode: '35D',
        swivelCode: '35D',
        syncCode: '35D',
        description: '35 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '36D': {
        code: enums_1.PartnerPaymentTerm['36D'],
        displayCode: '36D',
        bcCode: '36D',
        swivelCode: '36D',
        syncCode: '36D',
        description: '36 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '37D': {
        code: enums_1.PartnerPaymentTerm['37D'],
        displayCode: '37D',
        bcCode: '37D',
        swivelCode: '37D',
        syncCode: '37D',
        description: '37 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '38D': {
        code: enums_1.PartnerPaymentTerm['38D'],
        displayCode: '38D',
        bcCode: '38D',
        swivelCode: '38D',
        syncCode: '38D',
        description: '38 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '39D': {
        code: enums_1.PartnerPaymentTerm['39D'],
        displayCode: '39D',
        bcCode: '39D',
        swivelCode: '39D',
        syncCode: '39D',
        description: '39 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '40D': {
        code: enums_1.PartnerPaymentTerm['40D'],
        displayCode: '40D',
        bcCode: '40D',
        swivelCode: '40D',
        syncCode: '40D',
        description: '40 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '41D': {
        code: enums_1.PartnerPaymentTerm['41D'],
        displayCode: '41D',
        bcCode: '41D',
        swivelCode: '41D',
        syncCode: '41D',
        description: '41 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '42D': {
        code: enums_1.PartnerPaymentTerm['42D'],
        displayCode: '42D',
        bcCode: '42D',
        swivelCode: '42D',
        syncCode: '42D',
        description: '42 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '43D': {
        code: enums_1.PartnerPaymentTerm['43D'],
        displayCode: '43D',
        bcCode: '43D',
        swivelCode: '43D',
        syncCode: '43D',
        description: '43 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '44D': {
        code: enums_1.PartnerPaymentTerm['44D'],
        displayCode: '44D',
        bcCode: '44D',
        swivelCode: '44D',
        syncCode: '44D',
        description: '44 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '45D': {
        code: enums_1.PartnerPaymentTerm['45D'],
        displayCode: '45D',
        bcCode: '45D',
        swivelCode: '45',
        syncCode: '45',
        description: '45 days',
        applicableBillingEntities: allBillingEntities,
    },
    '46D': {
        code: enums_1.PartnerPaymentTerm['46D'],
        displayCode: '46D',
        bcCode: '46D',
        swivelCode: '46D',
        syncCode: '46D',
        description: '46 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '47D': {
        code: enums_1.PartnerPaymentTerm['47D'],
        displayCode: '47D',
        bcCode: '47D',
        swivelCode: '47D',
        syncCode: '47D',
        description: '47 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '48D': {
        code: enums_1.PartnerPaymentTerm['48D'],
        displayCode: '48D',
        bcCode: '48D',
        swivelCode: '48D',
        syncCode: '48D',
        description: '48 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '49D': {
        code: enums_1.PartnerPaymentTerm['49D'],
        displayCode: '49D',
        bcCode: '49D',
        swivelCode: '49D',
        syncCode: '49D',
        description: '49 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '50D': {
        code: enums_1.PartnerPaymentTerm['50D'],
        displayCode: '50D',
        bcCode: '50D',
        swivelCode: '50D',
        syncCode: '50D',
        description: '50 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '51D': {
        code: enums_1.PartnerPaymentTerm['51D'],
        displayCode: '51D',
        bcCode: '51D',
        swivelCode: '51D',
        syncCode: '51D',
        description: '51 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '52D': {
        code: enums_1.PartnerPaymentTerm['52D'],
        displayCode: '52D',
        bcCode: '52D',
        swivelCode: '52D',
        syncCode: '52D',
        description: '52 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '53D': {
        code: enums_1.PartnerPaymentTerm['53D'],
        displayCode: '53D',
        bcCode: '53D',
        swivelCode: '53D',
        syncCode: '53D',
        description: '53 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '54D': {
        code: enums_1.PartnerPaymentTerm['54D'],
        displayCode: '54D',
        bcCode: '54D',
        swivelCode: '54D',
        syncCode: '54D',
        description: '54 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '55D': {
        code: enums_1.PartnerPaymentTerm['55D'],
        displayCode: '55D',
        bcCode: '55D',
        swivelCode: '55D',
        syncCode: '55D',
        description: '55 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '56D': {
        code: enums_1.PartnerPaymentTerm['56D'],
        displayCode: '56D',
        bcCode: '56D',
        swivelCode: '56D',
        syncCode: '56D',
        description: '56 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '57D': {
        code: enums_1.PartnerPaymentTerm['57D'],
        displayCode: '57D',
        bcCode: '57D',
        swivelCode: '57D',
        syncCode: '57D',
        description: '57 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '58D': {
        code: enums_1.PartnerPaymentTerm['58D'],
        displayCode: '58D',
        bcCode: '58D',
        swivelCode: '58D',
        syncCode: '58D',
        description: '58 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '59D': {
        code: enums_1.PartnerPaymentTerm['59D'],
        displayCode: '59D',
        bcCode: '59D',
        swivelCode: '59D',
        syncCode: '59D',
        description: '59 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '60D': {
        code: enums_1.PartnerPaymentTerm['60D'],
        displayCode: '60D',
        bcCode: '60D',
        swivelCode: '60',
        syncCode: '60',
        description: '60 days',
        applicableBillingEntities: [...europeBillingEntities, ...chinaBillingEntities],
    },
    '61D': {
        code: enums_1.PartnerPaymentTerm['61D'],
        displayCode: '61D',
        bcCode: '61D',
        swivelCode: '61D',
        syncCode: '61D',
        description: '61 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '62D': {
        code: enums_1.PartnerPaymentTerm['62D'],
        displayCode: '62D',
        bcCode: '62D',
        swivelCode: '62D',
        syncCode: '62D',
        description: '62 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '63D': {
        code: enums_1.PartnerPaymentTerm['63D'],
        displayCode: '63D',
        bcCode: '63D',
        swivelCode: '63D',
        syncCode: '63D',
        description: '63 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '64D': {
        code: enums_1.PartnerPaymentTerm['64D'],
        displayCode: '64D',
        bcCode: '64D',
        swivelCode: '64D',
        syncCode: '64D',
        description: '64 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '65D': {
        code: enums_1.PartnerPaymentTerm['65D'],
        displayCode: '65D',
        bcCode: '65D',
        swivelCode: '65D',
        syncCode: '65D',
        description: '65 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '66D': {
        code: enums_1.PartnerPaymentTerm['66D'],
        displayCode: '66D',
        bcCode: '66D',
        swivelCode: '66D',
        syncCode: '66D',
        description: '66 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '67D': {
        code: enums_1.PartnerPaymentTerm['67D'],
        displayCode: '67D',
        bcCode: '67D',
        swivelCode: '67D',
        syncCode: '67D',
        description: '67 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '68D': {
        code: enums_1.PartnerPaymentTerm['68D'],
        displayCode: '68D',
        bcCode: '68D',
        swivelCode: '68D',
        syncCode: '68D',
        description: '68 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '69D': {
        code: enums_1.PartnerPaymentTerm['69D'],
        displayCode: '69D',
        bcCode: '69D',
        swivelCode: '69D',
        syncCode: '69D',
        description: '69 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '70D': {
        code: enums_1.PartnerPaymentTerm['70D'],
        displayCode: '70D',
        bcCode: '70D',
        swivelCode: '70D',
        syncCode: '70D',
        description: '70 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '71D': {
        code: enums_1.PartnerPaymentTerm['71D'],
        displayCode: '71D',
        bcCode: '71D',
        swivelCode: '71D',
        syncCode: '71D',
        description: '71 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '72D': {
        code: enums_1.PartnerPaymentTerm['72D'],
        displayCode: '72D',
        bcCode: '72D',
        swivelCode: '72D',
        syncCode: '72D',
        description: '72 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '73D': {
        code: enums_1.PartnerPaymentTerm['73D'],
        displayCode: '73D',
        bcCode: '73D',
        swivelCode: '73D',
        syncCode: '73D',
        description: '73 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '74D': {
        code: enums_1.PartnerPaymentTerm['74D'],
        displayCode: '74D',
        bcCode: '74D',
        swivelCode: '74D',
        syncCode: '74D',
        description: '74 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '75D': {
        code: enums_1.PartnerPaymentTerm['75D'],
        displayCode: '75D',
        bcCode: '75D',
        swivelCode: '75D',
        syncCode: '75D',
        description: '75 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '76D': {
        code: enums_1.PartnerPaymentTerm['76D'],
        displayCode: '76D',
        bcCode: '76D',
        swivelCode: '76D',
        syncCode: '76D',
        description: '76 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '77D': {
        code: enums_1.PartnerPaymentTerm['77D'],
        displayCode: '77D',
        bcCode: '77D',
        swivelCode: '77D',
        syncCode: '77D',
        description: '77 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '78D': {
        code: enums_1.PartnerPaymentTerm['78D'],
        displayCode: '78D',
        bcCode: '78D',
        swivelCode: '78D',
        syncCode: '78D',
        description: '78 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '79D': {
        code: enums_1.PartnerPaymentTerm['79D'],
        displayCode: '79D',
        bcCode: '79D',
        swivelCode: '79D',
        syncCode: '79D',
        description: '79 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '80D': {
        code: enums_1.PartnerPaymentTerm['80D'],
        displayCode: '80D',
        bcCode: '80D',
        swivelCode: '80D',
        syncCode: '80D',
        description: '80 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '81D': {
        code: enums_1.PartnerPaymentTerm['81D'],
        displayCode: '81D',
        bcCode: '81D',
        swivelCode: '81D',
        syncCode: '81D',
        description: '81 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '82D': {
        code: enums_1.PartnerPaymentTerm['82D'],
        displayCode: '82D',
        bcCode: '82D',
        swivelCode: '82D',
        syncCode: '82D',
        description: '82 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '83D': {
        code: enums_1.PartnerPaymentTerm['83D'],
        displayCode: '83D',
        bcCode: '83D',
        swivelCode: '83D',
        syncCode: '83D',
        description: '83 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '84D': {
        code: enums_1.PartnerPaymentTerm['84D'],
        displayCode: '84D',
        bcCode: '84D',
        swivelCode: '84D',
        syncCode: '84D',
        description: '84 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '85D': {
        code: enums_1.PartnerPaymentTerm['85D'],
        displayCode: '85D',
        bcCode: '85D',
        swivelCode: '85D',
        syncCode: '85D',
        description: '85 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '86D': {
        code: enums_1.PartnerPaymentTerm['86D'],
        displayCode: '86D',
        bcCode: '86D',
        swivelCode: '86D',
        syncCode: '86D',
        description: '86 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '87D': {
        code: enums_1.PartnerPaymentTerm['87D'],
        displayCode: '87D',
        bcCode: '87D',
        swivelCode: '87D',
        syncCode: '87D',
        description: '87 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '88D': {
        code: enums_1.PartnerPaymentTerm['88D'],
        displayCode: '88D',
        bcCode: '88D',
        swivelCode: '88D',
        syncCode: '88D',
        description: '88 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '89D': {
        code: enums_1.PartnerPaymentTerm['89D'],
        displayCode: '89D',
        bcCode: '89D',
        swivelCode: '89D',
        syncCode: '89D',
        description: '89 days',
        applicableBillingEntities: europeBillingEntities,
    },
    '90D': {
        code: enums_1.PartnerPaymentTerm['90D'],
        displayCode: '90D',
        bcCode: '90D',
        swivelCode: '90',
        syncCode: '90',
        description: '90 days',
        applicableBillingEntities: [...europeBillingEntities, ...chinaBillingEntities],
    },
    '10FM': {
        code: enums_1.PartnerPaymentTerm['10FM'],
        displayCode: '10FM',
        bcCode: '10FM',
        swivelCode: '10FM',
        syncCode: '10FM',
        description: 'Before the 10th of the following month',
        applicableBillingEntities: chinaBillingEntities,
    },
    '15CM': {
        code: enums_1.PartnerPaymentTerm['15CM'],
        displayCode: '15CM',
        bcCode: '15CM',
        swivelCode: '15CM',
        syncCode: '15CM',
        description: 'Before the 15th of the current month',
        applicableBillingEntities: chinaBillingEntities,
    },
    '15FM': {
        code: enums_1.PartnerPaymentTerm['15FM'],
        displayCode: '15FM',
        bcCode: '15FM',
        swivelCode: '15FM',
        syncCode: '15FM',
        description: 'Before the 15th of the following month',
        applicableBillingEntities: chinaBillingEntities,
    },
    '20CM': {
        code: enums_1.PartnerPaymentTerm['20CM'],
        displayCode: '20CM',
        bcCode: '20CM',
        swivelCode: '20CM',
        syncCode: '20CM',
        description: 'Before the 20th of the current month',
        applicableBillingEntities: chinaBillingEntities,
    },
    '20FM': {
        code: enums_1.PartnerPaymentTerm['20FM'],
        displayCode: '20FM',
        bcCode: '20FM',
        swivelCode: '20FM',
        syncCode: '20FM',
        description: 'Before the 20th of the following month',
        applicableBillingEntities: chinaBillingEntities,
    },
    '23CM': {
        code: enums_1.PartnerPaymentTerm['23CM'],
        displayCode: '23CM',
        bcCode: '23CM',
        swivelCode: '23CM',
        syncCode: '23CM',
        description: 'Before the 23rd of the current month',
        applicableBillingEntities: chinaBillingEntities,
    },
    '25CM': {
        code: enums_1.PartnerPaymentTerm['25CM'],
        displayCode: '25CM',
        bcCode: '25CM',
        swivelCode: '25CM',
        syncCode: '25CM',
        description: 'Before the 25th of the current month',
        applicableBillingEntities: chinaBillingEntities,
    },
    '25FM': {
        code: enums_1.PartnerPaymentTerm['25FM'],
        displayCode: '25FM',
        bcCode: '25FM',
        swivelCode: '25FM',
        syncCode: '25FM',
        description: 'Before the 25th of the following month',
        applicableBillingEntities: chinaBillingEntities,
    },
    BI_W: {
        code: enums_1.PartnerPaymentTerm['BI_W'],
        displayCode: 'BI-W',
        bcCode: 'BI-W',
        swivelCode: 'BI-W',
        syncCode: 'BI-W',
        description: '1st-15th settled on 20th, 16th-31st settled on 5th',
        applicableBillingEntities: chinaBillingEntities,
    },
    CM: {
        code: enums_1.PartnerPaymentTerm['CM'],
        displayCode: 'CM',
        bcCode: 'CM',
        swivelCode: 'CM',
        syncCode: 'CM',
        description: 'Last date on the current month',
        applicableBillingEntities: chinaBillingEntities,
    },
    COD: {
        code: enums_1.PartnerPaymentTerm['COD'],
        displayCode: 'COD',
        bcCode: 'COD',
        swivelCode: 'COD',
        syncCode: 'COD',
        description: 'CASH ON DELIVERY',
        applicableBillingEntities: chinaBillingEntities,
    },
    D20: {
        code: enums_1.PartnerPaymentTerm['D20'],
        displayCode: 'D20',
        bcCode: 'D20',
        swivelCode: 'D20',
        syncCode: 'D20',
        description: 'Current month 20th',
        applicableBillingEntities: chinaBillingEntities,
    },
    D5: {
        code: enums_1.PartnerPaymentTerm['D5'],
        displayCode: 'D5',
        bcCode: 'D5',
        swivelCode: 'D5',
        syncCode: 'D5',
        description: 'Current month 5th',
        applicableBillingEntities: chinaBillingEntities,
    },
    EFM: {
        code: enums_1.PartnerPaymentTerm['EFM'],
        displayCode: 'EFM',
        bcCode: 'EFM',
        swivelCode: 'EFM',
        syncCode: 'EFM',
        description: 'Before the end of the following month',
        applicableBillingEntities: chinaBillingEntities,
    },
};
//# sourceMappingURL=data:application/json;base64,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